<h1 mat-dialog-title>Confirmá tu solicitud</h1>

<div mat-dialog-content class="summary-content">
  <div class="summary-block">
    <p class="summary-label">Fecha de visita</p>
    <p class="summary-value">{{ formattedDate }}</p>
  </div>

  <div class="summary-block">
    <p class="summary-label">Momento de visita</p>
    <p class="summary-value">{{ data.schedulePreferenceLabel }}</p>
  </div>

  <div class="summary-block">
    <p class="summary-label">Dirección de visita</p>
    <p class="summary-value">{{ data.addressLine }}</p>
  </div>

  <div class="summary-block">
    <p class="summary-label">Tipo de servicio</p>
    <p class="summary-value">{{ data.serviceName }}</p>
  </div>

  <div class="summary-block">
    <p class="summary-label">Detalle de servicio</p>
    <p class="summary-value">
      {{ data.serviceDescription || 'Sin descripción registrada.' }}
    </p>
  </div>

  <div class="summary-block comment-block">
    <p class="summary-label">Comentarios</p>
    <textarea
      [formControl]="commentControl"
      placeholder="Escribí tus comentarios (opcional)"
      rows="4"
      resize="none"
    ></textarea>
    <small class="helper">Máximo 500 caracteres • Se enviará junto al pedido</small>
  </div>
</div>

<div mat-dialog-actions class="dialog-actions">
  <button
    type="button"
    class="ind-button-lite"
    (click)="onCancel()"
  >
    Cancelar
  </button>
  <button
    type="button"
    class="ind-button"
    (click)="onSubmit()"
    [disabled]="commentControl.invalid"
  >
    Solicitar servicio
  </button>
</div>

